<template>
  <WsCard class="ws-data-expand-list__item">
    <div
      v-if="!updateActive"
      @click="readContentToggle()"
      class="ws-data-expand-list__item__topbar"
    >
      <div v-if="!expandDisable">
        <v-icon v-if="readActive" size="28" class="ws-data-expand-list__item__topbar__icon"
          >mdi-unfold-less-horizontal</v-icon
        >
        <v-icon v-else size="28" class="ws-data-expand-list__item__topbar__icon"
          >mdi-unfold-more-horizontal</v-icon
        >
      </div>
      <div class="ws-data-expand-list__item__topbar__title">
        {{ _title }}
        <span class="ws-data-expand-list__item__topbar__title__tag" v-if="_isItemVersionUpdated">
          更新
        </span>
      </div>
      <WsLineGroup>
        <WsIconBtn v-if="itemEditable" @click="$_onUpdateClick()" :size="38" tooltip="編輯"
          >mdi-pencil</WsIconBtn
        >
        <WsIconBtn
          v-if="itemLinkEditable"
          @click="$_onUpdateClick()"
          :to="`/${modelName}/${value.id}/update`"
          :size="38"
          tooltip="編輯"
          >mdi-pencil</WsIconBtn
        >
        <WsIconBtn
          v-if="itemVersionLinkCreatable"
          :size="38"
          :to="`/${modelName}/${value.id}/version/create?redirect=${this.$route.fullPath}`"
          tooltip="更新版本"
          >mdi-update</WsIconBtn
        >
        <WsIconBtn
          v-if="_isShowCreateVersionBtn"
          :size="38"
          @click="$_onCreateVersion()"
          tooltip="更新版本"
          >mdi-update</WsIconBtn
        >
        <WsIconBtn
          v-if="itemVersionReadable"
          :to="$_itemVersionReadableUrl(value)"
          :size="38"
          tooltip="查看版本列表"
          >mdi-book-open-variant</WsIconBtn
        >
        <WsIconBtn v-if="itemDeletable" @click="$_onDelete(value.id)" :size="38" tooltip="刪除"
          >mdi-delete</WsIconBtn
        >
        <WsIconBtn
          v-if="itemLinkCheckable"
          :to="`/${this.modelName}/${this.value.id}`"
          :size="38"
          tooltip="查看"
          >mdi-eye</WsIconBtn
        >
        <template v-for="(item, index) in customBtns">
          <WsIconBtn
            :key="index"
            v-if="$_checkDisplay(item.isDisplay)"
            :size="38"
            :tooltip="item.tooltip"
            @click="$_onCustom(item)"
            >{{ item.icon }}</WsIconBtn
          >
        </template>
      </WsLineGroup>
    </div>
    <div v-if="readActive" class="ws-data-expand-list__item__content">
      <div v-if="isLoading" class="ws-data-expand-list__item__loading">
        <v-progress-circular size="20" color="primary" indeterminate></v-progress-circular>
      </div>
      <v-row v-else>
        <v-col
          v-for="(fieldKey, fieldIndex) in _displayFields"
          :key="fieldIndex"
          :cols="12"
          :sm="
            $_CMS_getFieldByFieldKey(fieldKey, fields).sm
              ? $_CMS_getFieldByFieldKey(fieldKey, fields).sm
              : 12
          "
          :style="{ display: $_displayCheck(fieldKey, fields, fetchValue) ? 'initial' : 'none' }"
        >
          <WsInfo
            :type="$_CMS_getFieldByFieldKey(fieldKey, fields).type"
            :label="$_CMS_getFieldByFieldKey(fieldKey, fields).label"
            :fields="$_CMS_getFieldByFieldKey(fieldKey, fields).fields"
            :textKey="$_CMS_getFieldByFieldKey(fieldKey, fields).textKey"
            :relationPopup="$_CMS_getFieldByFieldKey(fieldKey, fields).relationPopup"
            :modelName="$_CMS_getFieldByFieldKey(fieldKey, fields).modelName"
            :displayLabel="$_CMS_getFieldByFieldKey(fieldKey, fields).displayLabel"
            :getText="$_CMS_getFieldByFieldKey(fieldKey, fields).getText"
            :items="$_CMS_getFieldByFieldKey(fieldKey, fields).items"
            :value="$_CMS_getValueByFieldKey(fieldKey, fetchValue)"
            :locale="locale"
            :hideOnNull="hideOnNull"
            :originData="fetchValue"
            :displayCheck="$_CMS_getFieldByFieldKey(fieldKey, fields).displayCheck"
          ></WsInfo>
        </v-col>
      </v-row>
    </div>
    <!-- Delete Dialog -->
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      @submit="$_onDeleteSubmit($event)"
    />
    <!-- 虛擬滾動：表單放彈窗，避免 inline 撐高讓 DynamicScroller 反覆 relayout 卡死 -->
    <WsDialog
      v-if="itemState && updateActive"
      :value="updateActive"
      @input="$_onUpdateDialogInput($event)"
      :title="`編輯：${_title}`"
      persistent
      maxWidth="960px"
    >
      <template v-slot:content>
        <div v-if="isLoading" class="ws-data-expand-list__item__loading">
          <v-progress-circular size="20" color="primary" indeterminate></v-progress-circular>
        </div>
        <LvDataExpandUpdateForm
          v-else
          ref="updateForm"
          :fields="_updateFields"
          :updateData="updateData"
          :fetchValue="fetchValue"
          :value="value"
          :customParentData="customParentData"
          :modelData="modelData"
          @input="$_onInput"
        />
      </template>
      <template v-slot:rightActions>
        <WsBtn @click="$_onUpdateCancel()" minWidth="100px" color="textSecondary" outlined
          >取消</WsBtn
        >
        <WsBtn
          v-if="!groupSaving && !disableSaveBtn && !isLoading"
          @click="$_onUpdateSubmit()"
          minWidth="100px"
          :loading="updateSubmitLoading"
          color="primary"
          >儲存</WsBtn
        >
      </template>
    </WsDialog>
    <!-- 非虛擬：維持 inline 編輯 -->
    <template v-else-if="updateActive">
      <div class="ws-content no-border">
        <LvDataExpandUpdateForm
          ref="updateForm"
          :fields="_updateFields"
          :updateData="updateData"
          :fetchValue="fetchValue"
          :value="value"
          :customParentData="customParentData"
          :modelData="modelData"
          @input="$_onInput"
        />
      </div>
      <v-divider></v-divider>
      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <WsBtn @click="$_onUpdateCancel()" minWidth="100px" color="textSecondary" outlined
          >取消</WsBtn
        >
        <WsBtn
          v-if="!groupSaving && !disableSaveBtn"
          @click="$_onUpdateSubmit()"
          minWidth="100px"
          :loading="updateSubmitLoading"
          color="primary"
          >儲存</WsBtn
        >
      </v-card-actions>
    </template>
  </WsCard>
</template>

<script>
export default {
  data: () => ({
    readActive: false,
    updateActive: false,
    updateSubmitLoading: false,
    updateData: {},
    fetchValue: {},
    readData: {},
    updateReadData: {},
    isLoading: false,
    isStart: false,
    editType: '',
    // 開啟編輯且尚無完整內容 → 待父層補抓回來後，一次性用最新內容重建 updateData。
    // 一次性旗標：重建後即關閉，不受欄位元件「掛載即發 input」影響（editPristine 會被誤關）。
    editInitPending: false,
  }),
  methods: {
    $_onInput(fieldKey, $event) {
      this.updateData = {
        ...this.updateData,
        [fieldKey]: $event,
      };
    },
    $_scrollToTop() {
      if (this.itemState) return;
      this.$nextTick(() => {
        const rect = this.$el.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition = rect.top + scrollTop - 48;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      });
    },
    $_onUpdateCancel() {
      if (this.groupSaving) this.$emit('deleteGroupSave', this.fetchValue.id);
      else this.$emit('delete-changed-item', this.fetchValue.id);
      this.editType = '';
      this.updateActive = false;
      this.$_emitStateChange();
      this.$_scrollToTop();
    },
    $_finishUpdate() {
      this.updateSubmitLoading = false;
      this.$store.dispatch('app/stopNeedSave');
      this.updateActive = false;
      this.$_emitStateChange();
    },
    async $_onUpdateSubmit() {
      const isValidate = await this.$refs.updateForm.validate();
      if (!isValidate) {
        return;
      }
      this.updateSubmitLoading = true;
      try {
        if (this.customUpdateSubmitAction) {
          const { oldId, newId } = await this.customUpdateSubmitAction(
            this.updateData,
            this.fetchValue,
            this.editType,
            this.modelData,
          );
          await this.$_fetchData(newId);
          this.$emit('update-submit', { ...this.fetchValue, id: oldId, newId, custom: true });
          this.updateSubmitLoading = false;
          this.$store.dispatch('app/stopNeedSave');
          this.updateActive = false;
        } else if (this.hasSequence) {
          let postData = JSON.parse(JSON.stringify(this.updateData.last_version));
          if (this.customUpdateAction) postData = this.customUpdateAction(postData);
          if (this.editType === 'createVersion') {
            postData = {
              ...postData,
              ...this.postData,
            };
            postData[`${this.modelName}`] = this.value.id;
            postData[`${this.parentModelName}s`] = [this.params[`${this.parentModelName}s`]];
            const newModelData = await this.$axios.post(`/${this.modelVersionName}`, postData);
            await this.$_fetchData();
            this.$emit('update-submit', {
              ...newModelData.data.data,
            });
          } else {
            const newModelData = await this.$axios.patch(
              `/${this.modelVersionName}/${this.value.last_version.id}`,
              postData,
            );
            await this.$_fetchData();
            this.$emit('update-submit', {
              ...newModelData.data.data,
              id: this.fetchValue.last_version.id,
            });
          }
          this.$_finishUpdate();
        } else {
          let postData = JSON.parse(JSON.stringify(this.updateData));
          if (this.customUpdateAction) postData = this.customUpdateAction(postData);
          const res = await this.$axios.patch(`/${this.modelName}/${this.fetchValue.id}`, postData);
          this.$emit('update-submit', { ...postData, id: this.fetchValue.id, isPostData: true });
          if (this.fields.last_version) {
            if (this.fetchValue.last_version) {
              try {
                const newData = await this.$axios.patch(
                  `/${this._versionModelName}/${this.fetchValue.last_version.id}`,
                  this.updateData.last_version,
                );
                this.$_finishUpdate();
                this.$emit('update-submit', {
                  ...newData.data.data,
                  id: this.fetchValue.id,
                });
              } catch (error) {
                this.updateSubmitLoading = false;
                this.$store.dispatch('app/stopNeedSave');
                alert('更新錯誤');
                return;
              }
            } else {
              try {
                await this.$axios.post(
                  `/${this.modelName}/${res.data.data.id}/${this._versionModelName}`,
                  this.updateData.last_version,
                );
                this.$_finishUpdate();
                this.$emit('update-submit', {
                  ...this.updateData,
                  id: this.fetchValue.id,
                });
              } catch (error) {
                this.updateSubmitLoading = false;
                this.$store.dispatch('app/stopNeedSave');
                alert('更新錯誤');
                return;
              }
            }
          } else {
            this.$_finishUpdate();
            this.$emit('update-submit', {
              ...this.updateData,
              id: this.fetchValue.id,
            });
          }
        }
        // 編輯成功後讓父層展開內容 cache 失效，下次展開重抓最新資料
        this.$_invalidateContentCache();
        // 成功完成所有更新流程後，平滑捲動至組件頂部（往上留 48px 空間）
        this.$_scrollToTop();
      } catch (error) {
        this.updateSubmitLoading = false;
        this.$store.dispatch('app/stopNeedSave');
        alert(error.message || error || '更新錯誤');
      }
    },
    async $_onUpdateClick() {
      if (this.itemState) {
        // 虛擬滾動：child 不自抓（自抓會跨 await 被回收／寫到別筆 id），改委派父層 recycle-safe 補抓。
        // 不收合 readActive：編輯表單在彈窗、不影響此列高度；關窗後回到原本展開位置。
        // 已展開過（內容已快取）→ 直接用快取建 updateData，不再 force 重抓；
        // force 重抓會以新物件覆寫 fetchValue，連帶唯讀內容反覆重渲染、撐爆 DynamicScroller relayout → 當機。
        const loaded = !!(this.itemState.isContentLoaded && this.itemState.fetchValue);
        if (loaded) this.fetchValue = this.itemState.fetchValue;
        this.$_CMS_updateDataSetFromFields(this, this.updateData, this.fields, this.fetchValue);
        this.editType = '';
        this.updateActive = true;
        // 尚無完整內容才標記待補；抵達後由 itemState.fetchValue watcher 一次性重建 updateData
        this.editInitPending = !loaded;
        this.$_emitStateChange();
        if (!loaded) this.$_requestContent();
      } else {
        // 非虛擬：無父層委派管道（模板未綁 @request-content / @state-change），沿用原 child 自抓
        await this.$_fetchData();
        this.$_CMS_updateDataSetFromFields(this, this.updateData, this.fields, this.fetchValue);
        this.editType = '';
        this.readActive = false;
        this.updateActive = true;
      }
      setTimeout(() => {
        this.isMounted = true;
      }, 0);
    },
    // WsDialog 關閉（標題列 X / persistent 下）→ 走既有取消清理；guard 防 re-entry 迴圈
    $_onUpdateDialogInput(val) {
      if (!val && this.updateActive) this.$_onUpdateCancel();
    },
    async $_onCreateVersion() {
      await this.$_onUpdateClick();
      this.editType = 'createVersion';
      this.$_emitStateChange();
    },
    $_onDelete($event) {
      this.$refs.deleteDialog.open($event);
    },
    async $_onDeleteSubmit($event) {
      this.$refs.deleteDialog.startLoading();
      try {
        if (!this.hasSequence && !this.hasChapters && !this.groupSaving) {
          await this.$axios.delete(`/${this.modelName}/${$event}`);
        } else if (this.hasSequence) {
          await this.$axios.delete(`/${this.modelVersionName}/${this.fetchValue.last_version.id}`);
        }
        this.$emit('delete', $event);
      } catch (error) {
        alert(error);
      } finally {
        this.$refs.deleteDialog.close();
      }
    },
    async readContentToggle() {
      if (this.expandDisable) {
        return;
      }
      this.readActive = !this.readActive;
      this.$_emitStateChange();
      if (this.readActive) {
        // 虛擬滾動：抓內容交給父層（去重、且不受 child 被回收重建影響）；其餘情境維持 child 自抓
        if (this.itemState) {
          this.$_requestContent();
        } else {
          await this.$_fetchData();
        }
      }
    },
    // 通知父層抓取此 item 的展開內容（父層以 id 去重）
    $_requestContent() {
      if (this.itemState && this.itemState.isContentLoaded) return;
      // 虛擬滾動：內容由父層補抓，等待補回期間顯示 loading（補回後由 itemState.fetchValue watcher 關閉）
      this.isLoading = true;
      this.$emit('request-content', { id: this.value.id, modelName: this.modelName });
    },
    // 編輯成功後讓父層 cache 失效，下次展開強制重抓最新內容（避免顯示編輯前的舊資料）
    $_invalidateContentCache() {
      if (!this.itemState) return;
      this.$emit('state-change', {
        id: this.value.id,
        patch: { fetchValue: null, isContentLoaded: false },
      });
    },
    async $_fetchData(id) {
      if (this.articleSaving) return;
      this.isLoading = true;
      try {
        if (this.stopFetch) {
          return;
        }
        //get each of topic content
        const fetchId = id ? id : this.modelId;
        const res = await this.$axios.get(`/${this.modelName}/${fetchId}`);
        this.fetchValue = this.staticModelData
          ? this.staticModelData(res.data.data)
          : res.data.data;
        // 成功抓到內容後快取，recycle 重建時可直接還原、不必重抓（打破 fetch 迴圈）
        if (this.itemState) {
          this.$emit('state-change', {
            id: this.value.id,
            patch: { fetchValue: this.fetchValue, isContentLoaded: true },
          });
        }
      } catch (error) {
        alert(error);
      } finally {
        this.isLoading = false;
      }
    },
    $_itemVersionReadableUrl(data) {
      if (this.itemVersionReadableUrl) {
        return this.itemVersionReadableUrl(data);
      } else {
        return `/${this.modelName}/${this.value.id}/version`;
      }
    },
    $_checkDisplay(isDisplay) {
      if (!isDisplay) return;
      return true;
    },
    $_onCustom(item) {
      if (item.emit) {
        this.$emit('custom-event', {
          customEmitEvent: item.emit,
          customFunction: item.customFunction,
          itemId: this.value.last_version ? this.value.last_version.id : this.value.id,
          modelData: this.modelData,
          item: this.value,
        });
      }
      if (item.extraEmitList) {
        item.extraEmitList.forEach((extraEmit) => {
          this.$emit(
            extraEmit.event,
            extraEmit.setEmitData ? extraEmit.setEmitData(this.value) : this.value,
          );
        });
      }
    },
    $_displayCheck(fieldKey, fields, originData) {
      const displayCheck = this.$_CMS_getFieldByFieldKey(fieldKey, fields).displayCheck;
      if (displayCheck) {
        return displayCheck(originData);
      } else return true;
    },
    // 虛擬滾動 recycle：實例被重用到不同 item 時，依該 item 的父層 cache 完整還原本地狀態
    // （無 cache 則重置為收合，避免沿用前一筆的殘留狀態）
    $_hydrateFromState() {
      this.isHydrating = true;
      const state = this.itemState || {};
      this.readActive = !!state.readActive;
      this.updateActive = !!state.updateActive;
      this.editType = state.editType || '';
      this.editInitPending = !!state.editInitPending;
      this.updateData = state.updateData ? state.updateData : {};
      // 重設暫態 flag，避免無 :key 重用實例時把上一筆的 loading 狀態帶過來
      this.isLoading = false;
      this.updateSubmitLoading = false;
      // 已有「成功抓取過」的內容快取 → 直接還原，不再 fetch（避免 relayout→hydrate→fetch 迴圈）
      if (state.isContentLoaded && state.fetchValue) {
        this.fetchValue = state.fetchValue;
      } else {
        this.fetchValue = this.value;
        // 還原為展開/編輯但無快取內容 → 請父層抓（父層去重，避免重建重抓）
        if (this.readActive || this.updateActive) {
          this.$_requestContent();
        }
      }
      // hydrate 造成的 updateData 變動不應觸發 dirty / emit，等本輪 watcher flush 後再解除
      this.$nextTick(() => {
        this.isHydrating = false;
      });
    },
    // 虛擬滾動模式下，把展開/編輯狀態回寫父層 cache，回收後可還原
    $_emitStateChange() {
      if (!this.itemState) return;
      this.$emit('state-change', {
        id: this.value.id,
        patch: {
          readActive: this.readActive,
          updateActive: this.updateActive,
          editType: this.editType,
          editInitPending: this.editInitPending,
          updateData: this.updateData,
        },
      });
    },
  },
  computed: {
    _displayFields() {
      //show each of topic content
      const _displayFields = [];
      if (!this.hideOnNull) {
        this.fieldsRead.forEach((fieldKey) => {
          if (fieldKey.includes('last_version')) {
            const keyArr = fieldKey.split('.');
            const _value = this.$_CMS_getFieldByFieldKey(
              keyArr[1],
              this.fields.last_version.fields,
            );
            if (!(_value == undefined || _value.length == 0)) {
              _displayFields.push(fieldKey);
            }
          } else {
            const _value = this.$_CMS_getFieldByFieldKey(fieldKey, this.fields);
            if (!(_value == undefined || _value.length == 0)) {
              _displayFields.push(fieldKey);
            }
          }
        });
      } else {
        this.fieldsRead.forEach((fieldKey) => {
          const _value = this.$_CMS_getValueByFieldKey(fieldKey, this.fetchValue);
          if (
            (_value !== undefined && _value !== null) ||
            (Array.isArray(_value) && _value.length !== 0)
          ) {
            _displayFields.push(fieldKey);
          } else if (fieldKey.includes('last_version')) {
            const keyArr = fieldKey.split('.');
            if (
              this.fields.last_version.fields[keyArr[1]] !== undefined &&
              this.fields.last_version.fields[keyArr[1]].modelName &&
              this.fields.last_version.fields[keyArr[1]].type ===
                `${this.fields.last_version.fields[keyArr[1]].modelName}-picker` &&
              (this.fetchValue.last_version.article_versions ||
                this.fetchValue.last_version.act_version_alls)
            )
              _displayFields.push(fieldKey);
          } else {
            if (
              this.fields[fieldKey] &&
              this.fields[fieldKey].type === 'act-picker' &&
              (this.fetchValue.article_versions || this.fetchValue.act_version_alls)
            )
              _displayFields.push(fieldKey);
          }
        });
      }
      return _displayFields;
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
    _versionModelName() {
      return `${this.modelName}_version`;
    },
    _title() {
      return this.$_CMS_getValueByFieldKey(this.titleKey, this.value);
    },
    _isItemVersionUpdated() {
      let modelName = null;
      let isUpdated = false;
      if (this.modelName.includes('_version')) {
        let index = this.modelName.indexOf('_version');
        modelName = this.modelName.slice(0, index);
      }
      if (
        this.value[modelName] &&
        this.value[modelName][this.parentModelName] &&
        this.value[modelName][this.parentModelName].id === this.params[`${this.parentModelName}s`]
      )
        isUpdated = true;
      if (
        this.value[this.parentModelName] &&
        this.value[this.parentModelName].id === this.params[`${this.parentModelName}s`]
      )
        isUpdated = true;
      Object.keys(this.params).forEach((key) => {
        const _key = key.slice(0, key.length - 1);
        if (this.value[_key] && this.value[_key].id === this.params[key]) isUpdated = true;
      });
      if (
        this.fetchValue &&
        this.fetchValue[this.parentModelName] &&
        this.modelData &&
        this.modelData.last_version &&
        this.fetchValue[this.parentModelName].id === this.modelData.last_version.id
      )
        isUpdated = true;
      if (this.shouldShowUpdateTag)
        return this.shouldShowUpdateTag(this.modelData, this.fetchValue);
      return isUpdated;
    },
    _isShowCreateVersionBtn() {
      if (this._isItemVersionUpdated) return false;
      if (!this.itemVersionCreatable) return false;
      if (this.defaultBtnDisplayFunc)
        return this.defaultBtnDisplayFunc('itemVersionCreatable', this.modelData, this.fetchValue);
      else return true;
    },
  },
  props: {
    modeVersions: {
      type: Boolean,
      default: false,
    },
    modelName: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: 'name',
    },
    titleKey: {
      type: String,
      default: 'name',
    },
    value: {
      type: Object,
      default: null,
    },
    fields: {
      type: Object,
      default: null,
    },
    fieldsRead: {
      type: Array,
      default: null,
    },
    modelId: {
      type: Number,
      default: 0,
    },
    subVersionFields: {
      type: Object,
      default() {
        return {};
      },
    },
    subVersionFieldsReads: {
      type: Array,
      default() {
        return [];
      },
    },
    rootModelName: {
      type: String,
      default: '',
    },
    hideOnNull: {
      type: Boolean,
      default: true,
    },
    parentModelName: {
      type: String,
      default: '',
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    itemVersionCreatable: {
      type: Boolean,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
    },
    itemVersionReadable: {
      type: Boolean,
    },
    itemEditable: {
      type: Boolean,
    },
    itemDeletable: {
      type: Boolean,
    },
    itemLinkCheckable: {
      type: Boolean,
    },
    params: {
      type: Object,
    },
    postData: {
      type: Object,
    },
    isGetAll: {
      type: Boolean,
      default: false,
    },
    modelVersionName: {
      type: String,
      default: '',
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Object,
    },
    expandDisable: {
      type: Boolean,
      default: false,
    },
    stopFetch: {
      type: Boolean,
      default: false,
    },
    groupSaving: {
      type: Boolean,
      defalult: false,
    },
    articleSaving: {
      type: Boolean,
      default: false,
    },
    itemVersionReadableUrl: {
      type: Function,
    },
    itemLinkEditable: {
      type: Boolean,
    },
    customBtns: {
      type: Array,
      default() {
        return [];
      },
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
    staticModelData: {
      type: Function,
    },
    customUpdateAction: {
      type: Function,
    },
    modelData: {
      type: Object,
    },
    defaultBtnDisplayFunc: {
      type: Function,
    },
    customUpdateSubmitAction: {
      type: Function,
    },
    shouldShowUpdateTag: {
      type: Function,
    },
    itemState: {
      type: Object,
      default: null,
    },
  },
  watch: {
    updateData: {
      handler() {
        // hydrate 還原造成的變動不算使用者編輯，跳過 dirty / emit
        if (this.isHydrating) return;
        if (this.isMounted) {
          this.$store.dispatch('app/startNeedSave');
        }
        if (this.groupSaving) {
          this.$emit('groupSave', {
            ...this.fetchValue,
            ...this.updateData,
          });
        } else {
          this.$emit('item-changed', {
            ...this.fetchValue,
            ...this.updateData,
          });
        }
        this.$_emitStateChange();
      },
      deep: true,
    },
    value: {
      handler(newVal, oldVal) {
        // recycle 重用到「不同 item」(value 換了參考且 id 不同) → 完整還原該 item 狀態
        if (!oldVal || newVal.id !== oldVal.id) {
          this.$_hydrateFromState();
        } else if (!this.readActive && !this.updateActive) {
          // 同一筆資料更新且未展開 → 同步 fetchValue（沿用原行為）
          this.fetchValue = this.value;
        }
      },
      deep: true,
    },
    // 父層抓到內容寫回 cache 後，同步到本地 fetchValue 顯示
    'itemState.fetchValue': {
      handler(val) {
        if (!val) return;
        this.fetchValue = val;
        // 內容已補回 → 關閉展開時的 loading
        this.isLoading = false;
        // 編輯剛開啟且待補內容 → 用補抓抵達的最新內容一次性重建 updateData，重建後關閉旗標。
        // 視為系統刷新（非使用者編輯）：用 isHydrating 讓 updateData watcher 跳過 startNeedSave / item-changed，
        // 僅手動 $_emitStateChange 把最新 updateData 寫回 cache。
        if (this.updateActive && this.editInitPending) {
          this.isHydrating = true;
          this.$_CMS_updateDataSetFromFields(this, this.updateData, this.fields, this.fetchValue);
          this.editInitPending = false;
          this.$_emitStateChange();
          this.$nextTick(() => {
            this.isHydrating = false;
          });
        }
      },
    },
  },
  created() {
    // 初次掛載即依父層 cache 還原（非虛擬情境 itemState 為 null，等同 fetchValue = value）
    this.$_hydrateFromState();
  },
};
</script>

<!-- 非 scoped：WsDialog 內容會被 Vuetify detach 到 app root，scoped 的 data-v 對不到；改用唯一 BEM class 全域命中 -->
<style lang="scss">
.ws-data-expand-list__item__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
}
</style>
